define.alias("shared/utils/can-create-linkinbio-page", "calendar/utils/can-create-linkinbio-page");